
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";

const creators = [
  { id: "trey", name: "Trey Stone" },
  { id: "karen", name: "Karen Johnson" },
  { id: "miguel", name: "Miguel Santos" },
  { id: "chris", name: "Chris Wong" },
  { id: "jess", name: "Jessica Martinez" }
];

const CallForSolutionsCurator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedArea, setSelectedArea] = useState<string>("");
  const [isBounty, setIsBounty] = useState<string | null>(null);
  const [isAreaExpanded, setIsAreaExpanded] = useState(false);
  const [isBountyExpanded, setIsBountyExpanded] = useState(false);
  const [creator, setCreator] = useState<string>("");

  // Extract the data from location state
  useEffect(() => {
    if (location.state) {
      setSelectedArea(location.state.selectedArea || "");
      setIsBounty(location.state.isBounty || null);
    }
  }, [location]);

  const handleBack = () => {
    navigate("/call-for-solutions/bounty", { state: { selectedArea } });
  };

  const handleContinue = () => {
    // Navigate to the next step
    console.log("Creator selected:", creator);
    // For now just log - we'll add the next page later
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer"
          onClick={() => navigate("/engage")}
        />
      </div>

      <div className="w-full max-w-2xl space-y-6">
        {/* Functional Area Summary Card */}
        <Card className="border border-gray-200 overflow-hidden">
          <div 
            className="p-4 flex items-center justify-between cursor-pointer hover:bg-gray-50"
            onClick={() => setIsAreaExpanded(!isAreaExpanded)}
          >
            <div>
              <h2 className="text-xl font-semibold">Select Functional Area</h2>
              <p className="text-gray-600 mt-1">Selected: {selectedArea}</p>
            </div>
            <div>
              {isAreaExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </div>
          </div>
        </Card>

        {/* Solution Bounty Summary Card */}
        <Card className="border border-gray-200 overflow-hidden">
          <div 
            className="p-4 flex items-center justify-between cursor-pointer hover:bg-gray-50"
            onClick={() => setIsBountyExpanded(!isBountyExpanded)}
          >
            <div>
              <h2 className="text-xl font-semibold">Solution Bounty</h2>
              <p className="text-gray-600 mt-1">Is this a solution bounty? {isBounty === "yes" ? "Yes" : "No"}</p>
            </div>
            <div>
              {isBountyExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </div>
          </div>
        </Card>

        {/* Assign Creator Card */}
        <Card className="border border-gray-200">
          <CardContent className="p-6">
            <h2 className="text-xl font-semibold mb-2">Assign Creator</h2>
            <p className="text-gray-600 mb-6">Select and provide creator's contact information</p>
            
            <Select onValueChange={setCreator} value={creator}>
              <SelectTrigger className="w-full mb-8">
                <SelectValue placeholder="Select creator" />
              </SelectTrigger>
              <SelectContent>
                {creators.map(creator => (
                  <SelectItem key={creator.id} value={creator.id}>
                    {creator.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            {creator && (
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email Address
                  </label>
                  <Input type="email" placeholder="Enter creator's email" />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <Input type="tel" placeholder="Enter creator's phone" />
                </div>
              </div>
            )}
          </CardContent>
        </Card>

        {/* Navigation Buttons */}
        <div className="flex justify-between">
          <Button 
            variant="outline" 
            onClick={handleBack}
            className="border-gray-300"
          >
            Back
          </Button>
          
          <Button 
            onClick={handleContinue}
            disabled={!creator}
            className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CallForSolutionsCurator;
